import React from 'react';

import { useIntl } from 'react-intl-next';

import { FilterProductIcon } from '../../../../../common/ui/filters/filter-product-icon';
import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import SelectFilter from '../../../../../common/ui/filters/select-filter';
import { useSelectFilter } from '../../../../../controllers/filters/base-select-filter';
import {
	useFiltersDiscoverability2Enabled,
	usePrimaryProduct,
} from '../../../../../controllers/store/bootstrap';
import { filter as assetsSchemaFilter } from '../../../../../controllers/store/search/filters/assets-schema';

import { i18n } from './messages';

const AssetsSchemaFilter = ({
	isFilterInDropdown,
	showPrimaryProductIcon,
	fit,
	onClearOptions,
}: FilterProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const isFiltersDiscoverability2Enabled = useFiltersDiscoverability2Enabled();
	const [primaryProduct] = usePrimaryProduct();
	const [
		filterData,
		{ loadInitialOptions, setLookupInput, setOption, clearLookupInput, clearOptions },
	] = useSelectFilter({
		filterId: assetsSchemaFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const {
		isLoading,
		suggestedOptions,
		selectedOptions,
		options,
		isLookupDefined,
		lookupInput,
		isLookupActive,
	} = filterData;

	const groupedOptions = [
		{
			label: formatMessage(i18n.assetsFilterLabelSelected),
			options: selectedOptions,
		},
		{
			label: formatMessage(i18n.assetsFilterLabelUnselected),
			options: suggestedOptions,
		},
	];

	return (
		<SelectFilter
			contentFit={fit}
			canClearFilter
			checkboxIndicators
			onDropdownOpen={loadInitialOptions}
			onDropdownClose={clearLookupInput}
			onSearchInputChange={setLookupInput}
			onSelectChange={setOption}
			options={isLookupActive ? options : groupedOptions}
			selectedOptions={selectedOptions}
			label={formatMessage(i18n.assetsSchema)}
			placeholder={formatMessage(i18n.assetsFilterAssetsSchemaPlaceholder)}
			filterOrControlId={'assetsSchema'}
			isLoading={isLoading}
			isSearchable={isLookupDefined}
			searchInput={lookupInput}
			onClearOptions={() => {
				clearOptions();
				onClearOptions?.({ filterId: assetsSchemaFilter.id });
			}}
			iconBefore={
				<FilterProductIcon
					showPrimaryProductIcon={showPrimaryProductIcon}
					primaryProduct={primaryProduct}
				/>
			}
			isFilterInDropdown={isFilterInDropdown}
			isFiltersDiscoverability2Enabled={isFiltersDiscoverability2Enabled}
		/>
	);
};

export default AssetsSchemaFilter;
